import { useDispatch, useSelector } from '@betty/toolkit/state';
import {
  fetchDailyScratcher,
  selectDailyScratcher,
  selectDailyScratcherDataState,
  selectDailyScratcherStatus,
} from '../state';
import { useCallback, useEffect, useMemo } from 'react';

const useDailyScratcher = () => {
  const dispatch = useDispatch();
  const dailyScratcher = useSelector(selectDailyScratcher);
  const dailyScratcherStatus = useSelector(selectDailyScratcherStatus);
  const dailyScratcherState = useSelector(selectDailyScratcherDataState);

  const handleFetchDailyScratcher = useCallback(() => {
    dispatch(fetchDailyScratcher());
  }, [dispatch]);

  const isVisible = useMemo(() => {
    return dailyScratcherStatus !== 'NotAvailable' && dailyScratcher !== null;
  }, [dailyScratcherStatus, dailyScratcher]);

  useEffect(() => {
    if (dailyScratcherState === 'idle') {
      handleFetchDailyScratcher();
    }
  }, [dailyScratcherState, handleFetchDailyScratcher]);

  return {
    dailyScratcher,
    dailyScratcherState,
    dailyScratcherStatus,
    handleFetchDailyScratcher,
    isVisible,
    fetch: handleFetchDailyScratcher,
  };
};

export default useDailyScratcher;
